<template>
  <input-facade
      @input="emitPhoneNumber"
      class="form-control"
      v-model="phone"
      :masked="true"
      placeholder="+38(0__)___-__-__"
      mask="+38(0##)###-##-##"
      name="phoneNumber" type="tel"
  />
</template>

<script>
    export default {
      name: 'phone-input',
      props: {
          id: {
              type: String,
              required: false,
              default: '',
          },
          value: {
              type: String,
              required: false,
              default: null,
          },
      },
      data() {
          return {
            phone:'',
          };
      },
      updated() {
        if (this.value === '+38(0' || this.value === '+38(00'){
          this.phone = ''
          return
        }
        this.phone = this.value
      },
      methods: {
        emitPhoneNumber() {
                this.$emit('input', this.phone);
            },
      },
    }
</script>
